import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import styles from './loader.module.css'

interface LoaderProps extends Omit<ComponentPropsWithoutRef<'svg'>, 'width' | 'height'> {
  size?: 'small' | 'medium' | 'large'
}

export function Loader(props: LoaderProps): ReactElement {
  const { className, size = 'medium', ...rest } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="25 25 50 50"
      role="progressbar"
      aria-label="Loading..."
      width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
      height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
      className={clsx(styles.loader, className)}
      {...rest}
    >
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth={size === 'small' ? '4' : size === 'medium' ? '5' : '6'}
        className={styles.loaderCircle}
      />
    </svg>
  )
}
